/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Repertory from './component/repertory'
import { Spin } from 'antd'
import { startTime, endTime } from '../../util/index'

class ClubRepertory extends React.Component {
  static defaultProps = {
    repertoryList: {
      list: [],
    },
    repertoryDetail: [],
    period: {
      start_time: null,
      end_time: null,
    },
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    const data = {
      start_time: startTime(),
      end_time: endTime(),
    }
    this.props.fetchRepertoryList(data).then((res) => {
      this.setState({ loading: false })
    }) //默认值
  }

  componentWillUnmount() {
    this.props.getPeriod({ start_time: null, end_time: null }) //清除
  }

  render() {
    const { repertoryList, repertoryDetail, period } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Repertory
            list={repertoryList}
            repertoryDetail={repertoryDetail}
            period={period}
            fetchTimePeriod={this.props.fetchTimePeriod}
            getPeriod={this.props.getPeriod}
            fetchClubRepertoryDetail={this.props.fetchClubRepertoryDetail}
            fetchRepertoryList={this.props.fetchRepertoryList}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    repertoryList: state.getClubRepertory.repertoryList,
    repertoryDetail: state.getClubRepertory.repertoryDetail,
    period: state.getClubRepertory.period,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubRepertory))



// WEBPACK FOOTER //
// ./src/containers/ClubRepertory/index.js